/** Acento secundario TNO (reemplaza el amarillo/mostaza en heroes y UI global). */
export const tnoSecondaryLight = {
  light: '#4db6ac',
  main: '#00838f',
  dark: '#006064',
  contrastText: '#fff',
};

export const tnoSecondaryDark = {
  light: '#80deea',
  main: '#26a69a',
  dark: '#00897b',
  contrastText: '#fff',
};

/** Gradiente hero azul → índigo → teal (sin mostaza). */
export function getTnoHeroGradient(primary, secondary) {
  const accent = secondary || tnoSecondaryLight.main;
  return `linear-gradient(128deg, ${primary} 0%, #1a237e 34%, #283593 56%, ${accent} 100%)`;
}
